import React, { useCallback, useState } from "react";
import classNames from "classnames";
import { createBrowserHistory } from "history";
import dashboard from '../src/assets/images/Visacare_Images/dashboard.svg';
import dashboard_white from '../src/assets/images/Visacare_Images/dashboard_white.svg';
import userManage from '../src/assets/images/Visacare_Images/createEmployer.svg';
import userManage_white from '../src/assets/images/Visacare_Images/createEmployer_white.svg';
import userEdit from '../src/assets/images/Visacare_Images/employees.svg';
import userEdit_white from '../src/assets/images/Visacare_Images/employees_white.svg';
import setting from '../src/assets/images/Visacare_Images/setting.svg';
import setting_white from '../src/assets/images/Visacare_Images/setting_white.svg';
import reports from '../src/assets/images/Visacare_Images/chart-square-bar.svg';
import reports_white from '../src/assets/images/Visacare_Images/chart-square-bar_white.svg';
import home from '../src/assets/images/Visacare_Images/home.svg';
import home_white from '../src/assets/images/Visacare_Images/home_white.svg';
import dollar from '../src/assets/images/Visacare_Images/subscription.svg';
import dollar_white from '../src/assets/images/Visacare_Images/subscription_white.svg';
import cases from '../src/assets/images/Visacare_Images/briefcase.svg';
import cases_white from '../src/assets/images/Visacare_Images/briefcase_white.svg';
import signoutImage from '../src/assets/images/Visacare_Images/logout.svg';
import "./Appnewmenu.css";
import { MenuItem } from "primereact/MenuItem";

interface AppMenuProps {
  model: MenuItem[];
  className?: string;
  onMenuItemClick(event: { originalEvent: React.SyntheticEvent; item: MenuItem }): void;
}

interface AppSubmenuProps {
  className?: string;
  items: MenuItem[];
  onMenuItemClick(event: { originalEvent: React.SyntheticEvent; item: MenuItem }): void;
  root?: boolean;
}

const history = createBrowserHistory();

const AppSubmenu: React.FC<AppSubmenuProps> = ({ items, onMenuItemClick, className, root }) => {
  const [activeIndex, setActiveIndex] = useState<React.Key | null>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent, item: MenuItem, itemId: React.Key) => {
      const loggedInString = localStorage.getItem("AUTHDATA");

      if (loggedInString?.length > 0) {
        if (item.disabled) {
          event.preventDefault();
          return;
        }

        if (item.command) {
          item.command({ originalEvent: event, item });
        }

        if (item.items || !item.url) {
          event.preventDefault();
        }

        setActiveIndex(prev => (prev === itemId ? null : itemId));

        onMenuItemClick({ originalEvent: event, item });

      } else {
        const pathname = window.location.pathname;
        if (
          pathname !== "/" &&
          pathname !== "/passwordchange" &&
          pathname !== "/forgotusername" &&
          pathname !== "/uscis" &&
          pathname !== "/forgotPasswordUpdate"
        ) {
          window.location.href = "/";
        }
      }
    },
    [onMenuItemClick]
  );


  if (!items) return null;

  return (

    <div className="d-flex align-items-start sidebar-container">
      <div className="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        {items.map((item, i) => {
          const active = activeIndex === i;
          const buttonClass = classNames('nav-link', { active });

          return (
            <button
              key={i}
              className={buttonClass}
              id={`v-pills-${i}-tab`}
              data-bs-toggle="pill"
              data-bs-target={`#v-pills-${i}`}
              type="button"
              role="tab"
              aria-controls={`v-pills-${i}`}
              aria-selected={active}
              onClick={(e) => handleClick(e, item, i)}
              title={item.label}
            >
              {item.icon === "dashboard" && <img className="menu-iconl" alt="dashboard" src={active ? dashboard_white : dashboard} />}
              {item.icon === "userEdit" && <img className="menu-iconl" alt="userEdit" src={active ? userEdit_white : userEdit} />}
              {item.icon === "userManage" && <img className="menu-iconl" alt="userManage" src={active ? userManage_white : userManage} />}
              {item.icon === "reports" && <img className="menu-iconl" alt="reports" src={active ? reports_white : reports} />}              
              {item.icon === "home" && <img className="menu-iconl" alt="home" src={active ? home_white : home} />}
              {item.icon === "dollar" && <img className="menu-iconl large" alt="dollar" src={active ? dollar_white : dollar} />}
              {item.icon === "cases" && <img className="menu-iconl" alt="cases" src={active ? cases_white : cases} />}
              {item.icon === "setting" && <img className="menu-iconl" alt="setting" src={active ? setting_white : setting} />}
              {(item.icon !== "dashboard" &&
                item.icon !== "userEdit" &&
                item.icon !== "userManage" &&
                item.icon !== "reports" &&
                item.icon !== "setting" &&
                item.icon !== "home" &&
                item.icon !== "dollar" &&
                item.icon !== "cases") && <i className={item.icon}></i>}
            </button>
          );
        })}

        <div
          className="logout-section"
          role="button"
          tabIndex={0}
          title="Log Out"
          onClick={() => window.dispatchEvent(new Event("vc-open-logout"))}
          onKeyDown={(e) => e.key === "Enter" && window.dispatchEvent(new Event("vc-open-logout"))}
        >
          <img className="menu-iconl logout-icon" alt="Sign Out" src={signoutImage} />
        </div>
      </div>

      <div className="tab-content" id="v-pills-tabContent">
        {items.map((item, i) => {
          const active = activeIndex === i;
          const tabClass = classNames('tab-pane fade', { 'show active': active });

          return (
            <div
              key={i}
              className={tabClass}
              id={`v-pills-${i}`}
              role="tabpanel"
              aria-labelledby={`v-pills-${i}-tab`}
              tabIndex={0}
            >
              {item.items && (
                <AppSubmenu
                  items={item.items as MenuItem[]}
                  onMenuItemClick={onMenuItemClick}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>


  );
};




export const AppnewMenu: React.FC<AppMenuProps> = ({ model, className, onMenuItemClick }) => {

  // console.log("model", model)
  return (
    <div className="menu">
      <AppSubmenu
        items={model}
        className={className || "layout-main-menu"}
        onMenuItemClick={onMenuItemClick}
        root={true}
      />
    </div>
  );
};